import "./App.css";
import Navigation from "./navigation/navigation";
import "bootstrap/dist/css/bootstrap.min.css";
import { AuthorizationProvider } from "./services/auth/AuthorizationContext";
import { BrowserRouter, Route, Routes, useNavigate } from "react-router-dom";
import { useEffect } from "react";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { useDispatch } from "react-redux";
import { logout, setToken, setUser } from "../store/slices/userSlice";
import { routerPath } from "./navigation/path";

const App = () => {
	return (
		<main className="App">
			<AuthorizationProvider>
				<ToastContainer />
				<BrowserRouter>
					<SyncAcrossTabs />

					<Routes>
						<Route path="/*" element={<Navigation />}></Route>
					</Routes>
				</BrowserRouter>
			</AuthorizationProvider>
		</main>
	);
};

const SyncAcrossTabs = () => {
	const dispatch = useDispatch();
	const navigate = useNavigate();

	useEffect(() => {
		const handleStorageChange = (event) => {
			if (event.key === "token") {
				if (!event.newValue) {
					dispatch(logout());
					localStorage.clear();
					navigate(routerPath.Login);
				} else {
					try {
						const user = JSON.parse(localStorage.getItem("user"));
						const token = localStorage.getItem("token");
						if (user && token) {
							dispatch(setUser(user));
							dispatch(setToken(token));
						}
					} catch (error) {
						console.error("Error parsing localStorage data:", error);
						dispatch(logout());
						localStorage.clear();
						navigate(routerPath.Login);
					}
				}
			}
		};

		window.addEventListener("storage", handleStorageChange);

		return () => {
			window.removeEventListener("storage", handleStorageChange);
		};
	}, [dispatch, navigate]);

	return null;
};

export default App;
